import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SaveIcon from "@mui/icons-material/Save";
import TableChartIcon from "@mui/icons-material/TableChart";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Tab,
  Tabs
} from "@mui/material";
import { useState } from "react";
import Swal from "sweetalert2";
import axiosInstance from "../../../../utils/axios";
import ExcelUploader from "./ExcelUploader";

import PdfUploader from "./PdfUploader";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export default function UploadModal({
  open,
  closeModal,
  data,
  typeOfTheDividend,
  onSubmit,
  tabIndex = 0,
}) {
  const [tab, setTab] = useState(tabIndex);

  const [pdfFile, setPdfFile] = useState(null);
  const [excelFile, setExcelFile] = useState(null);

  const [excelInfo, setExcelInfo] = useState({
        issuerid: data?.issuer?.id,
        inwardDividendId: data?.id,
        dividendYear: "",
        dividendType: "",
      });

  const handleSubmit = async () => {
  if (tab === 1) {
    // Investor Excel Upload

    if (!excelFile) {
      Swal.fire("Please select an Excel file.");
      return;
    }

    if (!excelInfo.dividendYear) {
      Swal.fire("Please select Dividend Year.");
      return;
    }

    if (!excelInfo.dividendType) {
      Swal.fire("Please select Dividend Type.");
      return;
    }

    const formData = new FormData();

    formData.append("excelFiles", excelFile);
    formData.append(
      "inwarddividendType",
      excelInfo.dividendType
    );
    formData.append(
      "issuerid",
      excelInfo.issuerid
    );
    formData.append(
      "inwarddividendid",
      excelInfo.inwardDividendId
    );
    formData.append(
      "yearTypeDividend",
      excelInfo.dividendYear
    );

    try {
      const res = await axiosInstance.post(
        "/investor-informations",
        formData
      );

      if (res.data.payload.noofentry === 0) {
        Swal.fire({
          icon: "warning",
          title: "Excel contains no data.",
        });
        return;
      }

      Swal.fire({
        icon: "success",
        title: "Investor information uploaded successfully.",
      });

      closeModal();

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text:
          err.response?.data?.message ||
          "Something went wrong.",
      });
    }

    return;
  }

  // PDF upload
  if (onSubmit) {
    onSubmit({
      pdfFile,
      excelFile,
      dividendYear: excelInfo.dividendYear,
      dividendType: excelInfo.dividendType,
      data,
    });
  }
};

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      fullWidth
      maxWidth="lg"
      scroll="paper"
    >
      {/* <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          bgcolor: "#1976d2",
          color: "#fff",
        }}
      >
        <UploadFileIcon />
        <Typography variant="h6" fontWeight={600}>
          Inward Dividend Upload Center
        </Typography>
      </DialogTitle> */}

      <Tabs
        value={tab}
        onChange={(e, newValue) => setTab(newValue)}
        centered
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab
          icon={<PictureAsPdfIcon />}
          iconPosition="start"
          label="Forwarding Letter"
          disabled = {tabIndex === 1}
        />

        <Tab
          icon={<TableChartIcon />}
          iconPosition="start"
          label="Investor Data"
          disabled = {tabIndex === 0}
        />
      </Tabs>

      <Divider />

      <DialogContent
        dividers
        sx={{
          minHeight: "65vh",
          background: "#fafafa",
        }}
      >
        <TabPanel value={tab} index={0}>
          <PdfUploader
            file={pdfFile}
            setFile={setPdfFile}
          />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <ExcelUploader
            file={excelFile}
            setFile={setExcelFile}
            data={data}
            typeOfTheDividend={typeOfTheDividend}
            excelInfo={excelInfo}
            setExcelInfo={setExcelInfo}
          />
        </TabPanel>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Button
          variant="contained"
          color="error"
          startIcon={<CloseIcon />}
          onClick={closeModal}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
          onClick={handleSubmit}
          disabled={
                    tab === 1 &&
                    (
                        !excelFile ||
                        !excelInfo.dividendYear ||
                        !excelInfo.dividendType
                    )
                }
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}